onComplete(function () {
	// scroll

	window.addEventListener('scroll', () => {
		const scroll = window.pageYOffset || document.documentElement.scrollTop;
		const navHeader = document.querySelectorAll('.nav-header');
		if (scroll >= 35) {
			navHeader.forEach(el => el.classList.add('scroll'));
		} else if (scroll == 0) {
			navHeader.forEach(el => el.classList.remove('scroll'));
		}
	})
});